import React from 'react';
import { DocumentMagnifyingGlassIcon } from '@heroicons/react/24/outline';
import MarketStateStatDateCompetitorLowestItemDetails
	from '@app/model/market_state/MarketStateStatDateCompetitorLowestItemDetails';

const MarketStateProofLink: React.FunctionComponent<{
	companyHotelId: number
	item: MarketStateStatDateCompetitorLowestItemDetails
}> = ({ companyHotelId, item }) => {
	if (item.proofChoiceId == null) return null;

	return <a
		href={`/secured/proof/${companyHotelId}/choice/${item.proofChoiceId}`}
		target="_blank"
		rel="noopener noreferrer"
		title="View rate proof"
		aria-label="View rate proof in a new tab"
		className="inline-flex rounded text-sky-600 hover:text-sky-800 focus:outline-none focus:ring-2 focus:ring-sky-500"
	>
		<DocumentMagnifyingGlassIcon className="h-4 w-4" />
	</a>;
};

export default MarketStateProofLink;
